import { render, staticRenderFns } from "./DialogNewStage.vue?vue&type=template&id=3801fff2&scoped=true"
import script from "./DialogNewStage.vue?vue&type=script&lang=js"
export * from "./DialogNewStage.vue?vue&type=script&lang=js"
import style0 from "./DialogNewStage.vue?vue&type=style&index=0&id=3801fff2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3801fff2",
  null
  
)

export default component.exports